<template>
	<div>
		<app-header></app-header>
		<Row style="margin-top: 40px">
			<Col span="6">
				&nbsp;Test
			</Col>
			<Col span="12">
				&nbsp;
			</Col>
			<Col span="6">
				&nbsp;
			</Col>
		</Row>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted:function(){
            
        },
        watch:{
            
        },        
        methods: {

        },

    }
</script>


// WEBPACK FOOTER //
// AuditProject.vue?e5fb3ca0